/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserUpdateContextCto } from '../../models/user-update-context-cto';
import { UserUpdateCto } from '../../models/user-update-cto';

export interface UpdateUser$Json$Params {
  userId: string;
      body?: UserUpdateCto
}

export function updateUser$Json(http: HttpClient, rootUrl: string, params: UpdateUser$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<UserUpdateContextCto>> {
  const rb = new RequestBuilder(rootUrl, updateUser$Json.PATH, 'put');
  if (params) {
    rb.path('userId', params.userId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserUpdateContextCto>;
    })
  );
}

updateUser$Json.PATH = '/user/{userId}';
